/**
 * Middleware for async dispatch of actions
 * It is possible to invoke action.dispatch({type: SOME_ACTION_TYPE}) in reducer
 * @param {object} store store
 * @returns {function(*): Function} async dispatcher
 */
export const asyncDispatch = (store) => (next) => (action) => {
  let syncActivityFinished = false;
  let actionQueue = [];

  /**
   * Flushes the queue
   */
  function flushQueue() {
    actionQueue.forEach((act) => store.dispatch(act));
    actionQueue = [];
  }

  /**
   * Dispatches action async
   * @param {object} asyncAction action
   */
  function dispatch(asyncAction) {
    actionQueue = actionQueue.concat([asyncAction]);

    if (syncActivityFinished) {
      flushQueue();
    }
  }

  const result = next(
    {
      ...action,
      dispatch
    }
  );

  syncActivityFinished = true;
  flushQueue();

  return result;
};
